<div class="container-fluid">
  <app-header titleText="CUSTOMERS" i18n-titleText>
    <div button>
      <a *ngIf="canAddCustomer" routerLink="/customer/import" class="btn btn-bidit-navigate mr-1" i18n>Import Customer File</a>
      <a *ngIf="canAddCustomer" routerLink="/customer/add" class="btn btn-bidit-navigate" i18n>Add Customer</a>
    </div>
  </app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/customer_circle.png" alt="Customer Icon" class="card-icon" />
      <h5 i18n>Customer List</h5>

      <form (ngSubmit)="refreshSummary()">
        <div class="row">
          <div class="col-sm-3">
            <input name="customerName" id="customerName" class="form-control"
                   type="text" placeholder="Search Customers" i18n-placeholder
                   [(ngModel)]="filter.customerName" #customerName="ngModel" />
          </div>
          <div class="col-sm-3">
            <select name="customerType" id="customerType" class="form-control select-bidit"
                    [(ngModel)]="filter.customerType" #customerType="ngModel">
              <option value="null" i18n>Select Customer Type</option>
              <option *ngFor="let customerType of summary?.customerTypes" [ngValue]="customerType.customerType_ID">{{customerType.customerType_Desc}}</option>
            </select>
          </div>
          <div class="col-sm-3">
            <select name="salespersonId" id="salespersonId" class="form-control select-bidit"
                    [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
              <option value="" i18n>Select Salesperson</option>
              <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
            </select>
          </div>
          <div class="col-sm-3">
            <button type="submit" class="btn btn-bidit-action" onclick="this.blur();" i18n>Apply Filter</button>
          </div>
        </div><div class="row">
          <div class="col-sm-6">
            <label for="allLeads" class="mt-2" i18n>Active Customers</label>
            <input id="showInactive" name="showInactive"
                   type="checkbox" class="bidit-switch m-2" (change)="refreshSummary()"
                   [(ngModel)]="filter.showInactive" #showInactive="ngModel" />
            <label for="pastDue" class="mt-2" i18n>Inactive Customers</label>
          </div>
        </div>
      </form>

      <h5 i18n>Click on customer name below to edit customer file</h5>
      <app-spinner [isRunning]="dataSource.loading$ | async"></app-spinner>

      <mat-table class="table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
                 matSort matSortActive="customerName" matSortDirection="asc">
        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer Name</mat-header-cell>
          <mat-cell *matCellDef="let customer">
            <a routerLink="/customer/{{customer.customer_ID}}">
              {{customer.customer_BusinessName}}
            </a>
            <span *ngIf="customer.customer_IsActive==false">(Inactive)</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Phone</mat-header-cell>
          <mat-cell *matCellDef="let customer">
            {{customer.mainContact?.contact_Phone}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Email</mat-header-cell>
          <mat-cell *matCellDef="let customer">
            {{customer.mainContact?.contact_Email}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="customerType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer Type</mat-header-cell>
          <mat-cell *matCellDef="let customer">
            {{customer.customerType?.customerType_Desc}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="salesperson">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Salesperson</mat-header-cell>
          <mat-cell *matCellDef="let customer">
            <ng-template [ngIf]="customer.assignedTo">
              {{customer.assignedTo.lastName}}, {{customer.assignedTo.firstName}}
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header"></mat-header-cell>
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let customer">
            <a routerLink="/customer/{{customer.customer_ID}}" class="btn btn-bidit-edit mr-1"></a>
            <a *ngIf="canAddQuote" [routerLink]="['/quote/add']" [queryParams]="{customerId: customer.customer_ID}" class="btn btn-bidit-navigate" i18n>Add Quote</a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [length]="summary?.customerCount" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>
